<template>
  <div class="photo-album">
    <carousel
      ref="carousel"
      :swipe-on-desktop="swipeOnDesktop"
      :per-page="perPage"
      :carousel-identifier="carouselIdentifier"
      :slide-spacing="slideSpacing"
      :slide-padding="12"
      :class="{ 'carousel-square--two-slides': slideCount <= 2 }"
    >
      <slot></slot>
    </carousel>
  </div>
</template>

<script>
export default {
  name: 'photo-album',
  props: {
    tagging: { type: Object, required: true },
    actions: { type: Object, required: true },
    isSquared: { type: Boolean, default: false, required: false },
    swipeOnDesktop: { type: Boolean, default: true, required: false },
  },
  data() {
    return {
      carouselIdentifier: `carousel-${Date.now()}`,
      state: '',
      mediumScreen: window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches,
      largeScreen: window.matchMedia('(min-width: 1024px)').matches,
      slideCount: 0,
    };
  },
  computed: {
    perPage() {
      let perPage = 1;

      if (!this.isSquared) {
        return perPage;
      }

      if (this.largeScreen) {
        if (this.slideCount > 2) {
          perPage = 3;
        } else {
          perPage = 2;
        }
      }

      if (this.mediumScreen) {
        perPage = 2;
      }
      return perPage;
    },
    slideSpacing() {
      return this.isSquared ? {} : { 0: 0, 768: 150, 1024: 300 };
    },
  },
  watch: {
    perPage() {
      this.refreshCarouselLayout();
    },
    slideCount() {
      this.refreshCarouselLayout();
    },
  },
  mounted() {
    /* istanbul ignore next */
    if (window.eventBus) {
      window.eventBus.$on(`${this.carouselIdentifier}-pageChange`, this.onPageChange);

      window.eventBus.$on('mediaquery.changed', () => {
        this.syncScreenFlags();
      });
    }
    this.$nextTick(() => {
      this.slideCount = this.pageCountTotal();
      this.refreshCarouselLayout();
    });
  },
  methods: {
    syncScreenFlags() {
      this.mediumScreen = window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches;
      this.largeScreen = window.matchMedia('(min-width: 1024px)').matches;
      this.refreshCarouselLayout();
    },
    refreshCarouselLayout() {
      this.$nextTick(() => {
        if (this.$refs.carousel && this.$refs.carousel.computeCarouselSize) {
          this.$refs.carousel.computeCarouselSize();
        }
      });
    },
    onPageChange(currentSlide, prevSlide, from) {
      if (from) {
        this.state = this.actions.select;
      }

      if (currentSlide - prevSlide === -1 && !from) {
        this.state = this.actions.previous;
      } else if (currentSlide - prevSlide === 1 && !from) {
        this.state = this.actions.next;
      }

      this.label = this.getEventLabel(currentSlide);
    },
    pageCountTotal() {
      const pageCountLength = this.$el.querySelectorAll('.photo-album-slide').length;
      return pageCountLength;
    },
    // ignored as jsdom does not understand a DOM node of type <slide>
    /* istanbul ignore next */
    getEventLabel(currentSlide) {
      const slideNode = this.$el.querySelectorAll('.photo-album-slide')[currentSlide];
      let eventLabel = '';

      if (slideNode && slideNode.dataset) {
        eventLabel = slideNode.dataset && slideNode.dataset.taggingEventLabel;
      }

      return eventLabel;
    },
  },
};
</script>
